import React, { useState, useEffect } from "react";
import profile from "../../assets/profilePicture.png";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../../redux/actions/userActions";
import styles from "./Register.module.css";

const Register = ({ history }) => {
  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (userInfo) {
      history.push("/");
    }
  }, [history, userInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(register(name, email, phone, country));
  };
  console.log(userInfo)
  return (
    <div className={styles.container}>
      <header>
        <i className={styles.backIcon + " fas fa-chevron-left"}></i>
        <h1>Register</h1>
      </header>
      <main>
        <div className={styles.imgContainer}>
          <i className={styles.image + " fas fa-image"}></i>
          <img src={profile} alt="select-user-pic" />
          <i className={styles.camera + " fas fa-camera"}></i>
        </div>
        <div className={styles.fieldsContainer}>
          <div className={styles.field}>
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter Name"
              value={name}
              autoComplete="off"
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className={styles.field}>
            <label>Email Address</label>
            <input
              type="text"
              name="email"
              placeholder="Enter Email"
              value={email}
              autoComplete="off"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className={styles.field}>
            <label>Phone Number</label>
            <input
              type="text"
              name="phone"
              placeholder="Enter phone number"
              value={phone}
              autoComplete="off"
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <div className={styles.field}>
            <label>Country</label>
            <input
              type="text"
              name="country"
              placeholder="Enter Country"
              value={country}
              autoComplete="off"
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
          {/* <Link to="/verification"> */}
            <button onClick={handleSubmit}>Continue</button>
          {/* </Link> */}
        </div>
      </main>
    </div>
  );
};

export default Register;
